import React from "react";
import { createPortal } from "react-dom";
import { Snackbar, SnackbarContent } from "@material-ui/core";
import { CheckCircleOutline, Report } from '@material-ui/icons'

const withSnack = WrappedComponent => {
  return class extends React.Component {
    queue = [];
    constructor(props) {
      super(props);
      this.state = {
        snack: false,
        message: "",
        key: new Date().getTime(),
        kind: ''
      };
    }

    componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }



    openSnack = (message, kind) => {
      this.setState({ kind: kind });
      this.queue.push({
        message,
        key: new Date().getTime()
      });

      if (this.state.snack) {
        this.setState({ snack: false });
      } else {
        this.processQueue();
      }
    };

    processQueue = () => {
      if (this.queue.length > 0) {
        this.setState({
          snack: true,
          ...this.queue.shift()
        });
      }
    };

    _render() {
      const { snack, message, key, kind } = this.state;
      let bgcolor = '#00a987'
      let icon = <CheckCircleOutline style={{ marginRight: 10 }} /> ;

      switch (kind){
        case "warning":
          bgcolor = '#de810e';
          icon = <Report style={{ marginRight: 10 }}/> ;
        break;

        default:
        bgcolor = '#00a987';
      }

      return (
        <Snackbar
          key={key}
          autoHideDuration={3500}
          open={snack}
          onExited={this.processQueue}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          onClose={() => {
            this.setState({ snack: false });
          }}
        >
        <SnackbarContent
         aria-describedby="message-id2"
         style={{ backgroundColor: bgcolor }}
         message={
           <div style={{ display: 'flex', alignItems: 'center' }}>
             {icon}
             <span id="message-id2">
               <div>{message}</div>
             </span>
           </div>
          }
        />
        </Snackbar>
      );
    }

    render() {
      if (!this.defaultNode) {
        this.defaultNode = document.createElement("div");
        document.body.appendChild(this.defaultNode);
      }

      return (
        <React.Fragment>
          {createPortal(this._render(), this.defaultNode)}
          <WrappedComponent {...this.props} snack={this.openSnack} />
        </React.Fragment>
      );
    }
  };
};
export default withSnack;



// WEBPACK FOOTER //
// ./src/components/withSnack.js